<div class="pagination">

    <button class="first-page" [disabled]="currentPageValue === 1" (click)="goToFirstPage()">
        <img src="assets/icons/common/arrow-first-page.svg" alt="First page"/>
    </button>

    <button class="previous-page" [disabled]="currentPageValue === 1" (click)="goToPreviousPage()">
        <img src="assets/icons/common/arrow-left.svg" alt="Previous page"/>
    </button>

    <div class="page-results"><span class="first-item">{{firstItem}}</span> - <span class="last-item">{{lastItem}}</span> of <span class="total-items">{{pageData()?.totalElements}}</span></div>

    <button class="next-page" [disabled]="currentPageValue >= (pageData()?.totalPages ?? 0)" (click)="goToNextPage()">
        <img src="assets/icons/common/arrow-right.svg" alt="Next page"/>
    </button>

    <button class="last-page" [disabled]="currentPageValue >= (pageData()?.totalPages ?? 0)" (click)="goToLastPage()">
        <img src="assets/icons/common/arrow-last-page.svg" alt="Last page"/>
    </button>

</div>
